module.exports = __webpack_public_path__ + "media/images/new_home/phone-8da2b01099a9ee09e46ba6d81fb3bc20.svg";